export default {
  u18: [
    {
      koNm: '이재형',
      engNm: 'LEE JAEHYUNG',
      position: '감독',
      birthday: '1976년 09월 06일',
      education: '한양대학교',
      img: 'staff_u18_01'
    }, {
      koNm: '이진길',
      engNm: 'LEE JINGIL',
      position: '수석코치',
      birthday: '1990년 08월 04일',
      education: '숭실고등학교',
      img: 'staff_u18_02'
    }, {
      koNm: '장기석',
      engNm: 'JANG GISEOK ',
      position: 'GK코치',
      birthday: '1998년 05월 06일',
      education: '초당대학교',
      img: 'staff_u18_03'
    }, {
      koNm: '김보윤',
      engNm: 'KIM BOYUN',
      position: '피지컬코치',
      birthday: '2000년 07월 20일',
      education: '인천대학교',
      img: 'staff_u18_04'
    }, {
      koNm: '김예찬',
      engNm: 'KIM YECHAN',
      position: '의무',
      birthday: '1999년 05월 20일',
      education: '건양대학교',
      img: 'staff_u18_05'
    }
  ],
  u15: [
    {
      koNm: '윤승현',
      engNm: 'YUN SEUNGHYEON',
      position: '감독',
      birthday: '1988년 12월 13일',
      education: '연세대학교',
      img: 'staff_u15_02'
    }, {
      koNm: '김도정',
      engNm: 'KIM DOJEONG',
      position: '코치',
      birthday: '1994년 09월 08일',
      education: '남부대학교',
      img: 'staff_u15_04'
    }, {
      koNm: '정승일',
      engNm: 'JEONG SEUNGIL',
      position: 'GK코치',
      birthday: '2002년 04월 06일',
      education: '배재대학교',
      img: 'staff_u15_03'
    }, {
      koNm: '이용인',
      engNm: 'LEE YOUNIN',
      position: '의무',
      birthday: '1998년 01월 28일',
      education: '전주대학교',
      img: 'staff_u15_05'
    }
  ],
  u12: [
    {
      koNm: '김윤열',
      engNm: 'KIM YUNYOUL',
      position: '감독',
      birthday: '1974년 12월 03일',
      education: '배재대학교',
      img: 'staff_u12_01'
    }, {
      koNm: '오지상',
      engNm: 'OH JISANG',
      position: '코치',
      birthday: '2001년 06월 07일',
      education: '호원대학교',
      img: 'staff_u12_02'
    }
  ]
}
